export default [
  {
    header: 'Sub Accounts',
    title: 'Sub Accounts',
    name: 'sub-accounts',
    icon: 'UsersIcon',
    route: 'SubAccounts',
  },
  
]